import { render, staticRenderFns } from "./a21.vue?vue&type=template&id=96225672&scoped=true&"
import script from "./a21.vue?vue&type=script&lang=js&"
export * from "./a21.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96225672",
  null
  
)

export default component.exports